import styled from "@emotion/styled";
import { FC } from "react";
import { Link } from "react-router-dom";

import { Button, DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { AgentsRoutes } from "routes/agents/constants";

interface IProps {
  title: string;
  description: string;
  withActions?: boolean;
}

export const UnsubscribeCard: FC<IProps> = ({ title, description, withActions = false }) => {
  return (
    <Wrapper>
      <Background />
      <Icon name={IconsEnum.HelpDeskFullLogo} width="170px" height="32px" />
      <Card>
        <Icon name={IconsEnum.BellSleeping} width="64px" height="64px" />
        <Header>{title}</Header>
        <Description>{description}</Description>
        {withActions && (
          <Actions>
            <Button kind="primary" href={AgentsRoutes.AgentsMeEdit} size="large">
              Visit notification settings
            </Button>
            <HomeLinkWrapper>
              or <Link to="/">Go to HelpDesk</Link>
            </HomeLinkWrapper>
          </Actions>
        )}
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  gap: 80px;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 100vw;
  opacity: 0.2;
  background: conic-gradient(
    from 180deg at 50% 50%,
    #10b385 43.8091716170311deg,
    #d1f4d5 131.51010274887085deg,
    #f6f6f7 232.37839221954346deg,
    #ffc300 316.02848768234253deg
  );
  width: 100%;
  height: 100%;

  filter: blur(205px);
  z-index: -1;
`;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 62px;
  gap: 24px;
  background: var(${DesignToken.SurfacePrimaryDefault});
  border-radius: 24px;
  max-width: 612px;
`;

const Header = styled.h2`
  color: var(${DesignToken.IllustrationsStroke});
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.64px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Description = styled.div`
  color: var(${DesignToken.IllustrationsStroke});
  text-align: center;
  font-size: 20px;
  line-height: 150%;
`;

const HomeLinkWrapper = styled.div`
  margin-top: 12px;
  font-size: 14px;
`;
